import React from 'react'
import { ViewMode } from '../../types'
import { CalendarDays, Calendar } from 'lucide-react'

interface ViewToggleProps {
  currentView: ViewMode
  onViewChange: (view: ViewMode) => void
  className?: string
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  onViewChange,
  className = ''
}) => {
  return (
    <div className={`view-toggle-modern ${className}`}>
      <button
        onClick={() => onViewChange('today')}
        className={`view-toggle-btn flex items-center gap-1.5
          ${currentView === 'today' ? 'view-toggle-btn-active' : ''}
        `}
      >
        <Calendar className="w-3.5 h-3.5" />
        <span>今日</span>
      </button>
      <button
        onClick={() => onViewChange('week')}
        className={`view-toggle-btn flex items-center gap-1.5
          ${currentView === 'week' ? 'view-toggle-btn-active' : ''}
        `}
      >
        <CalendarDays className="w-3.5 h-3.5" />
        <span>本週</span>
      </button>
    </div>
  )
}

export default ViewToggle
